import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'

import { Box, Text } from '@fairfashion/design-system'

import { MapCard } from '../../components/MapCard/map-card.comp'

import { InvoicesChartCard } from './components/InvoicesChartCard/invoices-chart-card.comp'
import { ProvidersClientsCard } from './components/ProvidersClientsCard/providers-clients-card.comp'
import { ProvidersRisksCard } from './components/ProvidersRisksCard/providers-risks-card.comp'
import {
  ProviderDashboardContext,
  ProviderDashboardProvider,
} from './provider-dashboard.context'
import * as Styles from './provider-dashboard.styles'

const ProviderDashboardComp = () => {
  const [rightColumnSize, setRightColumnSize] = useState(0)

  const rightColumnRef = useRef<HTMLDivElement>(null)

  const { providersLocations, actions } = useContext(ProviderDashboardContext)

  useLayoutEffect(() => {
    const handleResize = () => {
      if (rightColumnRef.current) {
        if (window.innerWidth < 1000) {
          setRightColumnSize(400)
          return
        } else {
          setRightColumnSize(rightColumnRef.current.clientHeight)
        }
      }
    }

    window.addEventListener('resize', handleResize)

    if (rightColumnRef.current) {
      setRightColumnSize(rightColumnRef.current.clientHeight)
    }
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    actions.fetchProvidersLocations()
  }, [])

  return (
    <Box width="100%" direction="column" padding={3} gap={3}>
      <Box width="100%" alignItems="stretch" flexWrap="wrap" gap={3}>
        <Styles.FirstLineLeftColumn>
          <ProvidersClientsCard />
        </Styles.FirstLineLeftColumn>
        <Styles.FirstLineRightColumn>
          <ProvidersRisksCard />
        </Styles.FirstLineRightColumn>
      </Box>

      <Box width="100%" flexWrap="wrap" gap={3}>
        <Styles.SecondLineLeftColumn>
          <Box width="100%" height="100%">
            <MapCard
              center={providersLocations[0]}
              locations={providersLocations}
              header={<Text fontWeight={500}>Fornecedores</Text>}
              maxHeight={`${rightColumnSize}px`}
              mapOptions={{
                zoom: 3,
              }}
            />
          </Box>
        </Styles.SecondLineLeftColumn>
        <Styles.SecondLineRightColumn ref={rightColumnRef}>
          <InvoicesChartCard />
        </Styles.SecondLineRightColumn>
      </Box>
    </Box>
  )
}

export const ProviderDashboard = () => {
  return (
    <ProviderDashboardProvider>
      <ProviderDashboardComp />
    </ProviderDashboardProvider>
  )
}
